(ns ductile.scope-auth
  (:require [clojure.set :as set]
            [ductile.ui.locale :refer [tr]]))

(def all-scopes
  #_(-> (into (sorted-set :scope/transport-api :scope/inspect-unloadings) ;; FIXME: only used in routes
              (mapcat identity)
              (concat (vals (handlers->scopes))))
        (disj :ductile.lambda/public))
  (into (sorted-set)
        #{:scope/billing
          :scope/academy
          :scope/carriers
          :scope/carrier-billing
          :scope/gatebook ;; exporting the whole gatebook
          :scope/gate-control ;; entering & exiting vehicles
          :scope/manage-self-checkin ;; generate self-checkin links
          :scope/claimsecur-insurance-portal
          :scope/compound-admin
          :scope/compound-dashboard
          :scope/compound-dispo
          :scope/compound-entry
          :scope/compound-fahrzeug-announcements
          :scope/core-data.locations
          :scope/core-data.oem-data
          :scope/correct-vin
          :scope/customs-clearance
          :scope/ai-agent
          :scope/developer
          :scope/test-scenario
          :scope/dispo
          :scope/edi
          :scope/elog-service-completion
          :scope/inspect-unloadings
          :scope/inspect-workflow
          :scope/invoices
          :scope/kia-passive-custody
          :scope/manage-fuel-prices
          :scope/customer-portal
          :scope/bill-of-lading
          :scope/unloading-status
          :scope/compound-users
          :scope/user-scopes
          :scope/notifications
          :scope/scan-accessory-list
          :scope/schedule-unloading
          :scope/service-event-user
          :scope/service-list
          :scope/edi-api
          :scope/report-api
          :scope/scanner
          :scope/toggle-transport-prepared
          :scope/pegaso-monitoring
          :scope/train-entry
          :scope/transport-api
          :scope/transport-customer-price
          :scope/transports-overview
          :scope/trucks
          :scope/unloading-opening-times
          :scope/unloading-reception
          :scope/vehicle-search
          :scope/vehicle-exit-verification
          :scope/vin-list
          :scope/workflow}))

(def compound-worker-scopes
  {:scope/workflow #{:permission/read :permission/write}

   :scope/scanner #{:permission/read :permission/write}
   :scope/vehicle-search #{:permission/read :permission/write}

   :scope/service-list #{:permission/read}})

(def office-worker-scopes
  {:scope/vehicle-search #{:permission/read :permission/write}
   :scope/compound-dashboard #{:permission/read}
   :scope/inspect-workflow #{:permission/read :permission/write}
   :scope/workflow #{:permission/read :permission/write}
   :scope/compound-entry #{:permission/read :permission/write}
   :scope/vehicle-exit-verification #{:permission/read :permission/write}
   :scope/transports-overview #{:permission/read}
   :scope/toggle-transport-prepared #{:permission/read :permission/write}
   :scope/bill-of-lading #{:permission/read :permission/write}
   :scope/edi #{:permission/read}

   ;; :scope/manage-self-checkin #{:permission/read :permission/write}

   :scope/carriers #{:permission/read}
   :scope/trucks #{:permission/read}
   :scope/dispo #{:permission/read}
   :scope/compound-dispo #{:permission/read :permission/write}

   :scope/unloading-reception #{:permission/read :permission/write}
   :scope/schedule-unloading #{:permission/read :permission/write}
   :scope/unloading-opening-times #{:permission/read :permission/write}
   :scope/inspect-unloadings #{:permission/read :permission/write}

   :scope/scanner #{:permission/read :permission/write}
   :scope/service-list #{:permission/read}

   :scope/notifications #{:permission/read :permission/write}})

(def roles-controllable-by-compound-manager
  #{:role/entry-controller :role/compound-worker :role/compound-gate :role/compound-office-worker :role/lead-compound-worker})

(def ^:dynamic *role->scopes*
  (-> {;; ARS-specified roles
       ;; -----------------------------
       ;; Platzmitarbeiter
       :role/compound-worker compound-worker-scopes

       ;; Eingangskontrolleur
       :role/entry-controller (assoc compound-worker-scopes
                                     :scope/compound-entry #{:permission/read :permission/write})

       ;; Platzmeister
       :role/lead-compound-worker (assoc compound-worker-scopes
                                         :scope/compound-entry #{:permission/read :permission/write}
                                         :scope/compound-dashboard #{:permission/read}
                                         :scope/toggle-transport-prepared #{:permission/read :permission/write}
                                         :scope/transports-overview #{:permission/read}
                                         :scope/vehicle-exit-verification #{:permission/read :permission/write}
                                         :scope/schedule-unloading #{:permission/read :permission/write}
                                         :scope/unloading-opening-times #{:permission/read :permission/write})

       ;; Sicherheitsdienst/Pforte
       :role/compound-gate {;; in compound-ops:
                            ;; Ausgänge buchen, Stehenbleiber markieren (Book exits, mark standstills)
                            :scope/vehicle-exit-verification #{:permission/read :permission/write}

                            ;; Ladelistendruck, Ladungsvorbereitung anstoßen, Keine Änderung der Ladung
                            ;; Load list printing, Trigger load preparation, No change to the load
                            :scope/toggle-transport-prepared #{:permission/read :permission/write}
                            :scope/transports-overview #{:permission/read}
                            :scope/service-list #{:permission/read}

                            :scope/schedule-unloading #{:permission/read :permission/write}
                            :scope/unloading-reception #{:permission/read :permission/write}

                            :scope/scanner #{:permission/read :permission/write}
                            :scope/vehicle-search #{:permission/read}

                            ;;record entry and exit at the gate
                            :scope/gate-control #{:permission/read :permission/write}}

       ;; Sachbearbeiter
       :role/compound-office-worker office-worker-scopes

       ;; Niederlassungsleiter
       :role/compound-manager (merge office-worker-scopes
                                     {:scope/gatebook #{:permission/read}
                                      :scope/compound-admin #{:permission/read :permission/write}
                                      :scope/service-event-user #{:permission/read}
                                      :scope/compound-users #{:permission/read :permission/write}
                                      ;; View and preview invoices, No creation or dispatch
                                      :scope/invoices #{:permission/read}
                                      :scope/billing #{:permission/read}})

       ;; Accounting should be able to do everything (carrier, transports & compound) billing related.
       :role/accountant {:scope/invoices #{:permission/read :permission/write}
                         :scope/billing #{:permission/read :permission/write}
                         :scope/transport-customer-price #{:permission/read :permission/write}
                         :scope/carrier-billing #{:permission/read :permission/write}
                         :scope/carriers #{:permission/read :permission/write}
                         :scope/trucks #{:permission/read :permission/write}}

       ;; Controlling should be able to view invoices and generate previews.
       :role/accounting-manager {:scope/invoices #{:permission/read}
                                 :scope/billing #{:permission/read}}

       ;; Other roles
       ;; -----------------------------
       ;; Dispo
       :role/dispatcher {:scope/dispo #{:permission/read :permission/write}
                         :scope/compound-dispo #{:permission/read :permission/write}
                         :scope/transport-customer-price #{:permission/read :permission/write}
                         :scope/trucks #{:permission/read}
                         :scope/carriers  #{:permission/read}}

       ;; relevant to italian compounds:
       #_#_:role/unloading-office-worker {:scope/inspect-unloadings #{:permission/read :permission/write}
                                          :scope/unloading-reception #{:permission/read :permission/write}
                                          :scope/unloading-opening-times #{:permission/read :permission/write}
                                          :scope/schedule-unloading #{:permission/read :permission/write}
                                          :scope/unloading-status #{:permission/read :permission/write}}
       #_#_:role/unloading-customer {:scope/schedule-unloading #{:permission/read :permission/write}}}
      ;; all roles get read access to the academy
      (update-vals (fn [scopes] (assoc scopes :scope/academy #{:permission/read})))))

(def localization-of-roles
  ;; unused but needed to force localization keys
  ;; regenerate using:
  #_(mapv (fn [role] (list 'tr role)) (sort (keys *role->scopes*)))
  [(tr :role/accountant)
   (tr :role/accounting-manager)
   (tr :role/compound-gate)
   (tr :role/compound-manager)
   (tr :role/compound-office-worker)
   (tr :role/compound-worker)
   (tr :role/dispatcher)
   (tr :role/entry-controller)
   (tr :role/lead-compound-worker)])

(def all-roles
  (into #{} (keys *role->scopes*)))

(defn user->role-scopes
  "All scopes assigned to a user via roles, including scopes with both read or write permissions"
  [user]
  (into #{}
        (comp (mapcat (partial get *role->scopes*))
              (filter #(contains? (second %) :permission/read))
              (map first))
        (:user/roles user)))

(defn user->role-read-scopes
  "Scopes with read permissions assigned to a user via roles"
  [user]
  (into #{}
        (comp (mapcat (partial get *role->scopes*))
              (filter #(contains? (second %) :permission/read))
              (map first))
        (:user/roles user)))

(defn user->role-write-scopes
  "Scopes with write permissions assigned to a user via roles"
  [user]
  (into #{}
        (comp (mapcat (partial get *role->scopes*))
              (filter #(contains? (second %) :permission/write))
              (map first))
        (:user/roles user)))

(defn normalize-scopes [user]
  ;;All authenticated users get :scope/academy with read permissions
  (let [default-scopes {:scope/academy #{:permission/read}}
        user-scopes (set (:user/scopes user #{}))
        scope->permissions (reduce (fn [scope->permissions role]
                                     (let [scopes-from-role (*role->scopes* role)]
                                       (reduce (fn [scope->permissions [scope permissions]]
                                                 (update scope->permissions scope set/union permissions))
                                               scope->permissions
                                               scopes-from-role)))
                                   default-scopes
                                   (:user/roles user))]
    (-> user
        (update :user/roles set)
        (assoc :user/scopes (into user-scopes
                                  #_(comp (filter #(set/subset? #{:permission/read :permission/write} (second %)))
                                          (map first))
                                  (map first)
                                  scope->permissions))
        (assoc :user/write-scopes (into user-scopes
                                        (comp (filter #(contains? (second %) :permission/write))
                                              (map first))
                                        scope->permissions))
        (assoc :user/read-scopes (into user-scopes
                                       (comp (filter #(contains? (second %) :permission/read))
                                             (map first))
                                       scope->permissions)))))

(comment
  (require '[ductile.datomic.api :as dd])
  @(dd/transact dev/system [[:db/add [:user/email "dev@nextjournal.com"] :user/roles :role/dispatcher]])
  (def user (dd/entity (dev/db) [:user/email "dev@nextjournal.com"])))

(defn normalize-required-scope
  [required-scope]
  (if (keyword? required-scope)
    #{required-scope}
    (set required-scope)))

(defn authorized-for?
  "Truthy iff candidate scopes include authorization to the required scope.
  Handles administrator override."
  [candidate-scopes required-scope]
  (boolean (some (normalize-required-scope required-scope)
                 candidate-scopes)))

(defn user-authorized-for? [normalized-user required-scope]
  (authorized-for? (into #{}
                         (:user/scopes normalized-user))
                   required-scope))

#?(:clj
   (defn ductile-namespaces []
     (into (sorted-set)
           (comp (map ns-name)
                 (filter #(clojure.string/starts-with? (name %) "ductile.")))
           (all-ns))))

#?(:clj
   (defn ensure-set [scopes]
     (cond
       (set? scopes) scopes
       (keyword scopes) #{scopes}
       :else (throw (ex-info "invalid scope" {:scopes scopes})))))

#?(:clj
   (defn ns-sym->lambdas [ns-sym]
     (keep (fn [var]
             (when-let [scopes (-> var meta :ductile.lambda/scope)]
               {(symbol var) (ensure-set scopes)}))
           (vals (ns-publics (find-ns ns-sym))))))

(comment
  (ns-sym->lambdas 'ductile.transport))

#?(:clj
   (defn handlers->scopes []
     (into (sorted-map)
           (mapcat (comp ns-sym->lambdas ns-name))
           (ductile-namespaces))))

(comment
  (handlers->scopes))

#?(:clj
   (defn scopes->handlers []
     (update-vals (->> (handlers->scopes)
                       (mapcat (fn [[handler scopes]]
                                 (map (fn [scope]
                                        [scope handler])
                                      scopes)))
                       (group-by first)
                       (into (sorted-map)))
                  (partial into (sorted-set) (map second)))))

(comment
  (scopes->handlers))

(comment
  (ductile.spreadsheet/export-xlsx-file!
   {:title "Ductile Handlers & Scopes"}
   {:head (into ["handler"] (map name) all-scopes)
    :rows (into []
                (map (fn [[handler scopes]]
                       (into [handler]
                             (map #(when (contains? scopes %)
                                     "✔️"))
                             all-scopes)))
                (handlers->scopes))}))

(defn missing-write-permissions? [user scope]
  (and (not (contains? (normalize-required-scope scope) :ductile.lambda/public))
       (not (authorized-for? (:user/write-scopes user) scope))))

(defn check-lambda-scope! [user handler-var]
  ;; NOTE: moved from lambda ns to avoid circular dependencies
  (let [allowed-scopes (-> handler-var meta :ductile.lambda/scope)]
    (when-not (or (contains? (normalize-required-scope allowed-scopes)
                             :ductile.lambda/public)
                  ;; scopes assigned directly to user suffice
                  (authorized-for? (:user/read-scopes user) allowed-scopes))
      (throw (ex-info (str "not authorized `" (symbol handler-var) "`")
                      {:error :ductile.lambda/not-authorized
                       ::required-scope allowed-scopes})))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; protect individual data

(defn wrap-protected-value
  "Wraps `value` in a map, passing along information which `required-scopes` are needed to see the value.
  Use `unwrap-protected-value` to get back at the value.
  Use `ductile.ui.scopes.macros/with-scope-protected-value` for defining some UI that's dependent on a scope protected value being present."
  [required-scopes value]
  {:ductile.scope.protected-value/required-scopes required-scopes
   :ductile.scope.protected-value/value value})

(defn protect-value
  "Returns `value` wrapped by `wrap-protected-value` when `available-scopes` are sufficient for `required-scopes`. Returns `nil` otherwise.
  Use `unwrap-protected-value` to get back at the value.
  Use `ductile.ui.scopes.macros/with-scope-protected-value` for defining some UI that's dependent on a scope protected value being present."
  [required-scopes available-scopes value]
  (let [required-scopes (normalize-required-scope required-scopes)]
    (when (authorized-for? available-scopes required-scopes)
      (wrap-protected-value required-scopes value))))

(defn unwrap-protected-value
  "Extracts a protected value created with `protect-value`. Passes other values unchanged."
  [v]
  (if (map? v)
    (:ductile.scope.protected-value/value v v)
    v))

(defn required-scopes
  "Extracts required-scopes from a value created with `protect-value`. Returns `nil` otherwise"
  [v]
  (when (map? v)
    (:ductile.scope.protected-value/required-scopes v)))
